import { GregorioGlyph } from '../structures/GregorioGlyph';
import { GregorioNoteGlyph } from '../structures/GregorioNoteGlyph';
import { GregorioGlyphType } from '../enums/GregorioGlyphType';
import { GregorioLiquescentia } from '../enums/GregorioLiquescentia';
import { GregorioNoteElement } from '../structures/GregorioNoteElement';
import { GregorioType } from '../enums/GregorioType';
import { is_cavum } from './other';

export function close_normal_glyph(
  glyphs: GregorioGlyph[],
  notes: GregorioNoteElement[],
  orig_glyph_type: GregorioGlyphType,
  first_note_i: number,
  liquescentia: GregorioLiquescentia,
  current_note_i: number,
) {
  let glyph_type = orig_glyph_type;
  /* patch to have good glyph type in the case where a glyph ends by a note
  * with shape GregorioShape.QUADRATUM */
  if (glyph_type == GregorioGlyphType.PES_QUADRATUM_FIRST_PART ||
    glyph_type == GregorioGlyphType.PES_QUILISMA_QUADRATUM_FIRST_PART) {
    glyph_type = GregorioGlyphType.PUNCTUM;
  }

  const sliced = notes.slice(first_note_i, current_note_i + 1);
  gregorio_add_glyph(
    glyphs,
    sliced,
    glyph_type, 
    liquescentia,
    is_cavum(sliced));
}

function gregorio_add_glyph(
  glyphs: GregorioGlyph[],
  notes: GregorioNoteElement[],
  type: GregorioGlyphType,
  liquescentia: GregorioLiquescentia,
  is_cavum: boolean,
) {

  // gregorio_glyph * next_glyph = create_and_link_glyph(current_glyph);
  const next_glyph = new GregorioGlyph();
  next_glyph.notes = new GregorioNoteGlyph();
  next_glyph.type = GregorioType.GLYPH;
  next_glyph.notes.glyph_type = type;
  next_glyph.notes.liquescentia = liquescentia;
  next_glyph.notes.is_cavum = is_cavum;
  next_glyph.notes.notes = notes;

  glyphs.push(next_glyph);
}

export enum GREGORIO_SIGN_ORIENTATION {
  OVER,
  UNDER
}
